import { render, staticRenderFns } from "./CollapsibleContent.vue?vue&type=template&id=0b7c7b3a&scoped=true&"
import script from "./CollapsibleContent.vue?vue&type=script&lang=js&"
export * from "./CollapsibleContent.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleContent.vue?vue&type=style&index=0&id=0b7c7b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c7b3a",
  null
  
)

export default component.exports